const simonColors = [
  {
    showing: "#FAFF00",
    normal: "#DAAA00",
    name: "0",
  },
  {
    showing: "#1400FF",
    normal: "#5E50FF",
    name: "1",
  },
  {
    showing: "#00D715",
    normal: "#10861B",
    name: "2",
  },
  {
    showing: "#FF0000",
    normal: "#AD0707",
    name: "3",
  },
];

export default simonColors;
